import clsx from 'clsx'
import './uploading-tracks.scss'
import { useContext, useEffect, useState } from 'react'
import { UploadContext } from '../../contexts/UploadContext'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import ProgressBar from '../ProgressBar/ProgressBar'

const UploadingTracks = () => {
  const [uploadingFiles, setUploadingFiles] = useState({})
  const uploadContext = useContext(UploadContext)
  const files = Object.keys(uploadingFiles)
    .map((key) => {
      return { key: key, ...uploadingFiles[key] }
    })
    .filter((file) => file.status !== 'complete' && file.type === 'new')

  useEffect(() => {
    const interval = setInterval(() => {
      setUploadingFiles({ ...uploadContext.files })
    }, 100)
    return () => clearInterval(interval)
  }, [])

  function handleCancel(file) {
    uploadContext.cancelUpload(file)
  }

  return files?.length > 0 ? (
    <div className="pb-2 mb-2">
      {files.map((file) => (
        <div
          className={clsx(
            'uploading-track px-4 py-2 flex flex-row bg-white dark:bg-gray-blue mb-2 items-center',
            'rounded border-0 w-full text-left',
          )}
          key={file.key}
        >
          <div className="text-sm whitespace-nowrap flex-1">{file.name}</div>
          <ProgressBar percent={file.progress}>
            {file.status === 'processing' && (
              <div className="processing">
                <div>Processing File</div>
              </div>
            )}
          </ProgressBar>
          <div>
            <button
              onClick={() => handleCancel(file)}
              data-tooltip="Cancel Upload"
              className="bg-white-purple hover:bg-white dark:bg-gray-light dark:hover:bg-gray-dark ml-4 w-[24px] h-[24px] flex items-center  rounded-full"
            >
              <CloseIcon fill="#CCC" height="18" />
            </button>
          </div>
        </div>
      ))}
    </div>
  ) : null
}

export default UploadingTracks
